import React,{Component} from 'react';
import {connect} from 'react-redux';
import * as f2 from './store/actions';
class Table extends Component
{	
	
	edit(x)
	{
			this.props.edit(x)
	}
	del(id)
	{
		this.props.del(id)
	}
	render()
	{
		let {a,message}=this.props
	return (
			<div>
				<mark>server says {message}</mark>
				<h1>all students {a.length}</h1>
				<table>
					<thead>
						<tr>
							<th>id</th>
							<th>name</th>
							<th>email</th>
							<th>actions</th>
						</tr>
					</thead>
					<tbody>
						{a.map(x=>
								<tr key={x.id}>
									<td>{x.id}</td>
									<td>{x.name}</td>
									<td>{x.email}</td>
									<td>
										<button onClick={this.edit.bind(this,x)}>edit</button>
										<button onClick={this.del.bind(this,x.id)}>delete</button>
									</td>
								</tr>
						)}
					</tbody>
				</table>
			</div>
		)

	}
}
let f1=state=>state
export default connect(f1,f2)(Table);